export default __webpack_public_path__ + "static/media/rotation.e218eac8.svg";